import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography, Table, TableBody, TableCell, TableRow, TableHead, TextField, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

export default function ProgressTrackingEditDialog({
  open,
  onClose,
  onSave,
  sheetId,
  getColumnInfo,
  getDocument,
}) {
  const [columnInfo, setColumnInfo] = useState([]);
  const [formData, setFormData] = useState({});

  // 取得 schema + document
  useEffect(() => {
    if (open && sheetId) {
      Promise.all([getColumnInfo(), getDocument(sheetId)]).then(
        ([schema, doc]) => {
          setColumnInfo(schema || []);

          const initialData = {};
          schema.forEach((section) => {
            section.columns.forEach((col) => {
              const matchedCol =
                doc
                  ?.find((s) => s.id === section.id)
                  ?.columns?.find((c) => c.id === col.id) || {};

              initialData[`${col.id}_achievement`] =
                matchedCol.achievement_status_plan_content || "";
              initialData[`${col.id}_implementation`] =
                matchedCol.implementation_progress_content || "";
            });
          });
          setFormData(initialData);
        }
      );
    }
  }, [open, sheetId, getColumnInfo, getDocument]);

  const handleSave = (status) => {
    const data = (columnInfo || []).map((section) => ({
      ...section,
      columns: (section.columns || []).map((col) => ({
        ...col,
        achievement_status_plan_content:
          formData[`${col.id}_achievement`] ?? "",
        implementation_progress_content:
          formData[`${col.id}_implementation`] ?? "",
      })),
    }));

    onSave({ status, data, sheetId });
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      keepMounted
      disableRestoreFocus
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        onClose();
      }}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        編輯工作進度
        <IconButton
          aria-label="close"
          onClick={onClose}
          style={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {columnInfo.map((section) => (
          <Box
            key={section.id}
            mb={3}
            border={1}
            borderColor="#ddd"
            borderRadius={2}
          >
            <Box bgcolor="#cae3e8" p={1}>
              <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                {section.name}
              </Typography>
            </Box>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{ fontWeight: "bold" }}>項目</TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    達成情況/規劃
                  </TableCell>
                  <TableCell style={{ fontWeight: "bold" }}>
                    執行進度說明及後續規劃
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {section.columns.map((col) => (
                  <TableRow key={col.id}>
                    {/* 項目 */}
                    <TableCell style={{ width: "20%" }}>{col.name}</TableCell>

                    {/* 達成情況/規劃 */}
                    <TableCell style={{ width: "40%" }}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        multiline
                        value={formData[`${col.id}_achievement`] || ""}
                        placeholder={
                          col?.achievement_status_plan_description || ""
                        }
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            [`${col.id}_achievement`]: e.target.value,
                          })
                        }
                        InputProps={{
                          style: {
                            overflow: "auto",
                            resize: "none",
                            whiteSpace: "pre-wrap",
                          },
                        }}
                      />
                    </TableCell>

                    {/* 執行進度說明及後續規劃 */}
                    <TableCell style={{ width: "40%" }}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        multiline
                        // rows={5}
                        value={formData[`${col.id}_implementation`] || ""}
                        placeholder={
                          col?.implementation_progress_description || ""
                        }
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            [`${col.id}_implementation`]: e.target.value,
                          })
                        }
                        InputProps={{
                          style: {
                            overflow: "auto",
                            resize: "none",
                            whiteSpace: "pre-wrap",
                          },
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        ))}
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => handleSave(1)}
          style={{
            backgroundColor: "#fff",
            color: "#5597b4",
            border: "1px solid #5597b4",
            borderRadius: "6px",
            marginRight: 8,
          }}
        >
          暫存
        </Button>
        <Button
          onClick={() => handleSave(2)}
          style={{
            backgroundColor: "#5597b4",
            color: "#fff",
            borderRadius: "6px",
            marginRight: 8,
          }}
          variant="contained"
        >
          完成
        </Button>
        <Button
          onClick={onClose}
          style={{
            backgroundColor: "#fff",
            color: "#555",
            border: "1px solid #ccc",
            borderRadius: "6px",
          }}
        >
          取消
        </Button>
      </DialogActions>
    </Dialog>
  );
}
